import { buildSignInUrl } from '@/services/customerApiCompat'
import { logger } from '@/services/logger'

export const getTokenErrorHandler = async (error: unknown) => {
  logger.error(error)
  return window.location.href = buildSignInUrl({ redirect: window.location.href })
}
